import { render, staticRenderFns } from "./PouchBundleSave.vue?vue&type=template&id=ace7658c&scoped=true&"
import script from "./PouchBundleSave.vue?vue&type=script&lang=js&"
export * from "./PouchBundleSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace7658c",
  null
  
)

export default component.exports